import "./CustomInput.css";

import React, { FocusEventHandler, useState } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface CustomInputProps {
  label?: string;
  id?: string;
  type?: string;
  placeholder?: string;
  value?: any;
  defaultValue?: any;
  setValue: React.Dispatch<React.SetStateAction<any>>;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  containerStyle?: any;
  labelStyle?: any;
  inputStyle?: any;
  maxLength?: number;
  pattern?: string;
  error?: string;
  autoCapitalize?: string;
  disabled?: boolean;
  onBlur?: FocusEventHandler<HTMLInputElement> | undefined;
  inputContainerStyle?: any;
  icon?: any;
}

const CustomInput = ({
  label,
  id,
  type,
  placeholder,
  value,
  defaultValue,
  setValue,
  onKeyPress,
  autoComplete,
  containerStyle,
  labelStyle,
  inputStyle,
  maxLength,
  error,
  autoCapitalize,
  onBlur,
  disabled,
  inputContainerStyle,
  icon,
}: CustomInputProps) => {
  const [hidden, setHidden] = useState<boolean>(false);
  return (
    <>
      <div className="custom-input-container" style={containerStyle}>
        <label style={labelStyle}>{label}</label>
        <div className="input-container" style={inputContainerStyle}>
          <input
            id={id ? id : ""}
            disabled={disabled}
            maxLength={maxLength}
            style={inputStyle}
            type={type && !hidden ? type : "text"}
            value={value}
            defaultValue={defaultValue}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (type === "tel" || type === "ID") {
                setValue(
                  e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*?)\..*/g, "$1")
                );
              } else {
                setValue(e.target.value);
              }
            }}
            onKeyPress={onKeyPress ? onKeyPress : () => {}}
            autoComplete={autoComplete ? autoComplete : "off"}
            autoCapitalize={autoCapitalize ? autoCapitalize : "none"}
          />
          {icon ? icon : null}
          {type &&
            type === "password" &&
            (!hidden ? (
              <FontAwesomeIcon
                className="eye"
                icon={faEye}
                onClick={() => setHidden(!hidden)}
              />
            ) : (
              <FontAwesomeIcon
                className="eye"
                icon={faEyeSlash}
                onClick={() => setHidden(!hidden)}
              />
            ))}
        </div>
        {error ? (
          <p className="error-text">
            <div dangerouslySetInnerHTML={{ __html: error }} />
          </p>
        ) : null}
      </div>
    </>
  );
};

export default CustomInput;
